<template>
  <!--
https://api.nobiasinvesting.com/auth/register
{"first_name" : "John", "last_name" : "Cena", "email" : "johncena@hotmail.com", "password" : "asdf1234", "role" : 0, "status" : true, "pin" : "1234", "parked" : false, "trial_expiry" : "" }
  --->
  <div class="card">
    <div class="card-header">
      <div class="row">
        <div class="col-md-10">
          <strong class="card-title ">{{ (!user) ? 'Add' : 'Edit' }} User</strong>
        </div>
        <div class="col-md-2">
          <goback></goback>
        </div>
      </div>
    </div>
    <div class="card-body pb-0">
      <div>
        <div class="mb5"></div>
        <!-- <vform :formData="editForm" :fields="fields" :submitCallback="showSmallModal"/> -->
        <form class="form-horizontal" @onsubmit.prevent action>
          <div class="row">
            <div class="col-md-6">
              <div class="form-group" :class="{ 'has-error': validation.hasError('firstname') }">
                <label class="form-control-label">First Name</label>
                <input type="text" class="form-control inmarginbtm" placeholder="First Name" value
                  v-model="firstname" />
                <div class="error">{{ validation.firstError('firstname') }}</div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label class="form-control-label">Last Name</label>
                <input type="text" class="form-control" placeholder="Last Name" value v-model="lastname" />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <div class="form-group" :class="{ 'has-error': validation.hasError('email') }">
                <label class="form-control-label">Email</label>
                <input type="email" class="form-control" placeholder="Email Id *" v-model="email" />
                <div class="error">{{ validation.firstError('email') }}</div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group" :class="{ 'has-error': validation.hasError('mobile') }">
                <label class="form-control-label">Mobile</label>
                <input type="number" class="form-control" minlength="10" maxlength="10" placeholder="Mobile *"
                  v-model="mobile" />
                <div class="error">{{ validation.firstError('mobile') }}</div>
              </div>
            </div>
            <div class="col-md-6" v-show="user == ''">
              <div class="form-group" :class="{ 'has-error': validation.hasError('pin') }">
                <label class="form-control-label">PIN</label>
                <input type="password" class="form-control" placeholder="Choose New Pin *" minlength="4"
                  v-model="pin" />
                <div class="error">{{ validation.firstError('pin') }}</div>
              </div>
            </div>
          </div>
          <div class="row" v-show="user == ''">
            <div class="col-md-6">
              <div class="form-group" :class="{ 'has-error': validation.hasError('password') }">
                <label class="form-control-label">Password</label>
                <input type="password" class="form-control" placeholder="Choose Password *" v-model="password" />
                <div class="error">{{ validation.firstError('password') }}</div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group" :class="{ 'has-error': validation.hasError('cpassword') }">
                <label class="form-control-label">Confirm Password</label>
                <input type="password" class="form-control" placeholder="Confirm Password *" v-model="cpassword" />
                <div class="error">{{ validation.firstError('cpassword') }}</div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <div class="form-group" :class="{ 'has-error': validation.hasError('status') }">
                <label for="select-status" class="form-control-label">Status</label>
                <select id="select-status" class="form-control" v-model="status">
                  <option value>Select Status</option>
                  <option v-for="(f, index) in userStatus" :value="f.id" :key="index + f.value">{{ f.value }}</option>
                </select>
                <div class="error">{{ validation.firstError('status') }}</div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group" :class="{ 'has-error': validation.hasError('role') }">
                <label for="select-role" class="form-control-label">Role</label>
                <select id="select-role" class="form-control" v-model="role" @change="changeRole()">
                  <option value>Select Role</option>
                  <option v-for="(f, index) in userRoles" :value="f.id" :key="index + f.value">{{ f.value }}</option>
                </select>
                <div class="error">{{ validation.firstError('role') }}</div>
              </div>
            </div>
          </div>
          <div class="row" v-if="showTrialExpiry">
            <div class="col-md-6">
              <div class="form-group">
                <label for="select-role" class="form-control-label">Expiry Date</label>
                <datepicker :input-class="'form-control'" :format="'dd-MM-yyyy'" v-model="trial_expiry"
                  @selected="getDateData($event)"></datepicker>
              </div>
            </div>
          </div>
          <div class="raw">
            <div class="col-md-12" v-if="errors && errors.length > 0">{{ errors }}</div>
          </div>
          <div class="form-group pull-right">
            <button type="button" @click="regUser" class="btn btn-info" v-if="!user">Submit</button>
            <button type="button" @click="updateUser" class="btn btn-info" v-if="user">Update</button>
          </div>
        </form>
        <!-- <PinCheck
          :show.sync="show"
          ref="smallModal"
          v-bind:small="true"
          @submitForm="submitForm"
          :cancelClass="'btn btn-secondary'"
        ></PinCheck>-->
      </div>
      <ClientDetails />
    </div>
  </div>
</template>
<script>
// import vform from "@/components/vform";
import http from "@/lib/http";
import { commonMixins } from "../../assets/mixins/common.js";
// import PinCheck from "@/components/PinCheck.vue";
import Datepicker from "vuejs-datepicker";
import SimpleVueValidation from "simple-vue-validator";
import ClientDetails from "./client-details.vue";
var Validator = SimpleVueValidation.Validator;
export default {
  // props: ["user"],
  components: { Datepicker, ClientDetails },
  mixins: [commonMixins],
  created() {
    console.log("Created", this.user, this.$route.params);
    if (this.$route.params.id) {
      this.id = parseInt(this.$route.params.id);
      this.getUserDetails();
    }
  },
  data() {
    return {
      registerDetails: {},
      user: "",
      id: "",
      firstname: "",
      lastname: "",
      email: "",
      mobile: "",
      password: "",
      cpassword: "",
      role: "",
      status: "",
      pin: "",
      parked: 0,
      trial_expiry: "",
      errors: [],
      submitted: false,
      userStatus: [{ id: 0, value: "Inactive" }, { id: 1, value: "Active" }],
      userRoles: [
        { id: 0, value: "Super Admin" },
        { id: 1, value: "Admin" },
        { id: 2, value: "Premium User" },
        { id: 3, value: "Free User" },
      ],
      showTrialExpiry: false
    };
  },
  validators: {
    firstname: function (value) {
      return Validator.value(value).required();
    },
    email: function (value) {
      return Validator.value(value)
        .required()
        .email();
    },
    mobile: function (value) {
      return Validator.value(value)
        .required()
        .minLength(10)
        .maxLength(10);
    },
    pin: function (value) {
      return Validator.value(value)
        .required()
        .minLength(4);
    },
    status: function (value) {
      return Validator.value(value).required();
    },
    role: function (value) {
      return Validator.value(value).required();
    },
    password: function (value) {
      return Validator.value(value)
        .required()
        .minLength(6);
    },
    "cpassword, password": function (cpassword, password) {
      if (this.submitted || this.validation.isTouched("cpassword")) {
        return Validator.value(cpassword)
          .required()
          .match(password);
      }
    }
  },
  methods: {
    regUser() {
      var _this = this;
      this.submitted = true;
      this.$validate().then(success => {
        // console.log('on success ' + success)
        if (success) {
          this.registerDetails = {
            first_name: this.firstname,
            last_name: this.lastname,
            email: this.email,
            mobile: this.mobile,
            password: this.password,
            cpassword: this.cpassword,
            pin: this.pin,
            status: this.status,
            parked: this.parked,
            trial_expiry: this.getDate(this.trial_expiry),
            role: this.role
          };
          console.log("register details", this.registerDetails);
          http.post("auth/register", this.registerDetails, function (
            error,
            response
          ) {
            if (!error) {
              console.log("response", response);
              if (response.status === "success") {
                _this.$toastr.success(response.message, "", {});
                _this.clearForm();
                _this.$router.push({ name: "users" });
              } else {
                _this.errors = response.message;
              }
            } else {
              console.log("error", error);
            }
          });
        }
      });
    },
    clearForm() {
      this.registerDetails = {};
      (this.firstname = ""),
        (this.lastname = ""),
        (this.email = ""),
        (this.mobile = ""),
        (this.password = ""),
        (this.cpassword = ""),
        (this.pin = ""),
        (this.status = true),
        (this.parked = false),
        (this.trial_expiry = ""),
        (this.role = 0);
    },
    updateUser() {
      var _this = this;
      this.submitted = true;
      console.log("User Status", this.status);
      this.$validate(["firstname", "email"]).then(success => {
        // console.log('on success ' + success)
        if (success) {
          this.registerDetails = {
            first_name: this.firstname,
            last_name: this.lastname,
            email: this.email,
            mobile: this.mobile,
            status: this.status,
            role: this.role,
            trial_expiry: this.getDate(this.trial_expiry)
          };
          console.log("User details", this.registerDetails);
          http.post("user/edit/" + this.user.id, this.registerDetails, function (
            error,
            response
          ) {
            if (!error) {
              console.log("response", response);
              if (response.responseType === "success") {
                _this.$toastr.success(response.message, "", {});
                _this.clearForm();
                _this.$router.push({ name: "users" });
                // setTimeout(() => { _this.$router.push({name: "user-listing"}) }, 100);
              } else {
                _this.errors = response.message;
              }
            } else {
              console.log("error", error);
            }
          });
        }
      });
    },
    getUserDetails() {
      var _this = this;
      http.get("user/" + _this.id, {}, (error, response) => {
        _this.user = response;
        _this.firstname = _this.user.first_name;
        _this.lastname = _this.user.last_name;
        _this.email = _this.user.email;
        _this.mobile = _this.user.mobile;
        _this.password = _this.user.password;
        _this.cpassword = _this.user.cpassword;
        _this.pin = _this.user.pin;
        _this.status = _this.user.status && _this.user.status === true ? 1 : 0;
        _this.parked = _this.user.parked && _this.user.parked === true ? 1 : 0;
        const trialDate =
          _this.user.trial_expiry !== ""
            ? _this.user.trial_expiry.split("-")
            : _this.user.trial_expiry;
        _this.trial_expiry = new Date(trialDate);
        _this.role = _this.user.role;
        if (_this.user.role == "2") {
          this.showTrialExpiry = true;
          if (_this.user.trial_expiry !== "") {
            const trialDate = _this.user.trial_expiry.split("-");
            _this.trial_expiry = new Date(
              trialDate[1] + "-" + trialDate[0] + "-" + trialDate[2]
            );
          } else {
            _this.trial_expiry = this.user.trial_expiry;
          }
        } else {
          this.showTrialExpiry = false;
        }
        console.log("status", _this.status);
      });
    },
    getUserRoles() {
      http.get("roles", {}, (error, response) => {
        console.log(response);
      });
    },
    changeRole() {
      console.log(this.role);
      if (this.role === 3) {
        const date = new Date();
        this.trial_expiry = new Date(date.setMonth(date.getMonth() + 1));
        this.showTrialExpiry = true;
      } else {
        this.trial_expiry = "";
        this.showTrialExpiry = false;
      }
    },
    getDateData(e) {
      console.log(e);
    }
  },
  watch: {
  }
};
</script>
<style>
form .col-md-3 {
  width: 40%;
}
</style>



// WEBPACK FOOTER //
// src/views/acl/add-user.vue